export function isNotNull<T>(value: T | null): value is T {
	return value !== null;
}

export function isDefined<T>(value: T | undefined): value is T {
	return value !== undefined;
}
